import { IntlFormatters } from 'react-intl';

import Joi from 'joi';

export const personalProfileValidationSchema = ({
  formatMessage,
}: Pick<IntlFormatters, 'formatMessage'>) => {
  const firstNameLabel = formatMessage({
    id: 'developer_personal_page_personal_profile_first_name',
  });

  const lastNameLabel = formatMessage({
    id: 'developer_personal_page_personal_profile_last_name',
  });

  const dial_country_code = formatMessage({
    id: 'developer_personal_page_personal_profile_country_isd',
  });

  const phoneLabel = formatMessage({
    id: 'developer_personal_page_personal_profile_phone',
  });

  return Joi.object({
    first_name: Joi.string()
      .trim()
      .max(100)
      .required()
      .pattern(/^[a-zA-Z ]*$/)
      .messages({
        'string.empty': formatMessage(
          { id: 'generalForm_validation_required' },
          { field: firstNameLabel }
        ),
        'any.required': formatMessage(
          { id: 'generalForm_validation_required' },
          { field: firstNameLabel }
        ),
        'string.max': formatMessage(
          { id: 'generalForm_validation_range' },
          { field: firstNameLabel, min: 1, max: 100 }
        ),
        'string.pattern.base': formatMessage(
          { id: 'developer_personal_page_personal_profile_name_validation' },
          { field: firstNameLabel }
        ),
      })
      ,
    last_name: Joi.string()
      .trim()
      .max(100)
      .required()
      .pattern(/^[a-zA-Z ]*$/)
      .messages({
        'string.empty': formatMessage(
          { id: 'generalForm_validation_required' },
          { field: lastNameLabel }
        ),
        'any.required': formatMessage(
          { id: 'generalForm_validation_required' },
          { field: lastNameLabel }
        ),
        'string.max': formatMessage(
          { id: 'generalForm_validation_range' },
          { field: lastNameLabel, min: 1, max: 100 }
        ),
        'string.pattern.base': formatMessage(
          { id: 'developer_personal_page_personal_profile_name_validation' },
          { field: lastNameLabel }
        ),
      }),
    dial_country_id: Joi.object()
      .required()
      .messages({
        'any.required': formatMessage(
          { id: 'generalForm_validation_required' },
          { field: dial_country_code }
        ),
      }),
    isd_code: Joi.string().optional(),
    phone_number: Joi.string()
      .trim()
      // eslint-disable-next-line
      .pattern(/^[0-9]*$/)
      .min(10)
      .required()
      .messages({
        'string.empty': formatMessage({ id: 'generalForm_validation_required' }, { field: phoneLabel }),
        'string.pattern.base': formatMessage(
          { id: 'developer_personal_page_personal_profile_phone_number_validation' },
          { field: phoneLabel }
        ),
        'string.min': formatMessage(
          { id: 'registrationForm_phone_validation' },
          { field: phoneLabel,character:10 }
        ),
      }),
  });
};
